import { UseQueryOptions, useQuery } from 'react-query';
import { query as StardogQuery } from 'stardog';

import { useStardogConnectionFromPortalIndex } from 'bones/utils/portal/useStardogConnectionFromPortalIndex';

const VOICEBOX_CATALOG_PROVIDERS_QUERY = `# Voicebox Catalog Providers

PREFIX catalog: <tag:stardog:api:catalog:>

SELECT (COUNT(*) AS ?count)
WHERE {
    GRAPH catalog:providers {
        ?s ?p ?o .
    }
}
`;

export const usePortalVoiceboxCatalogProvidersMissing = (
  connectionIdx: number,
  catalogDatabaseId?: string,
  options?: UseQueryOptions<boolean | null>
) => {
  const stardogConnection = useStardogConnectionFromPortalIndex(connectionIdx);
  return useQuery<boolean | null>(
    `usePortalVoiceboxCatalogProvidersMissing-${
      stardogConnection ? connectionIdx : null
    }-${catalogDatabaseId}`,
    async () => {
      if (!stardogConnection || !catalogDatabaseId) {
        return null;
      }

      const queryResponse = await StardogQuery.execute(
        stardogConnection,
        catalogDatabaseId,
        VOICEBOX_CATALOG_PROVIDERS_QUERY
      );

      if (!queryResponse.ok) {
        throw new Error(
          queryResponse.statusText || String(queryResponse.status)
        );
      }

      const bindings: Array<{
        count?: { value?: string };
      }> = queryResponse.body?.results?.bindings || [];
      const missing = bindings.reduce<boolean>((acc, binding) => {
        return acc || parseInt(binding?.count?.value || '') === 0;
      }, false);

      return missing;
    },
    options
  );
};
